import {
    ON_START_GET_DIALER_USER_HISTORY,ON_GET_DIALER_USER_HISTORY,ON_ERROR_GET_DIALER_USER_HISTORY,
    ON_START_GET_DIALER_KOMMUN_LIST,ON_GET_DIALER_KOMMUN_LIST,ON_ERROR_GET_DIALER_KOMMUN_LIST,
    ON_START_GET_DIALER_AVTALSTID_LIST,ON_GET_DIALER_AVTALSTID_LIST,ON_ERROR_GET_DIALER_AVTALSTID_LIST,
    ON_START_UPPDATE_DIALER_KOMMMENTAR, ON_UPPDATE_DIALER_KOMMMENTAR, ON_ERROR_UPPDATE_DIALER_KOMMMENTAR,
ON_START_FETCH_STATISTIC_KAMPANJER,ON_FETCH_STATISTIC_KAMPANJER,ON_ERROR_FETCH_STATISTIC_KAMPANJER,
ON_START_FETCH_HIT_COUNT,  ON_FETCH_HIT_COUNT,  ON_ERROR_FETCH_HIT_COUNT,
ON_SET_NULL_MESSAGE_DIALER,
ON_START_FETCH_RL_PREPARE,ON_FETCH_RL_PREPARE,ON_ERROR_FETCH_RL_PREPARE,
ON_START_FETCH_KUND_LIST,ON_FETCH_KUND_LIST,ON_ERROR_FETCH_KUND_LIST,
ON_START_NEW_RINGLIST,ON_NEW_RINGLIST,ON_ERROR_NEW_RINGLIST,
ON_START_FETCH_KAMPANJER_ALL,ON_FETCH_KAMPANJER_ALL,ON_ERROR_FETCH_KAMPANJER_ALL,
ON_START_FETCH_KAMPANJER,ON_FETCH_KAMPANJER,ON_ERROR_FETCH_KAMPANJER,
ON_START_DELETE_KAMPANJER, ON_DELETE_KAMPANJER, ON_ERROR_DELETE_KAMPANJER,
ON_START_FETCH_KUND_LIST_BYID,ON_FETCH_KUND_LIST_BYID,ON_ERROR_FETCH_KUND_LIST_BYID,
ON_START_FETCH_KAMPANJ_BYID,ON_FETCH_KAMPANJ_BYID,ON_ERROR_FETCH_KAMPANJ_BYID,
ON_START_UPDATE_RINGLIST,ON_UPDATE_RINGLIST,ON_ERROR_UPDATE_RINGLIST,
ON_START_FETCH_KUND_LISTVY_BYID,ON_FETCH_KUND_LISTVY_BYID,ON_ERROR_FETCH_KUND_LISTVY_BYID,
ON_START_FLAG_RINGLIST,ON_FLAG_RINGLIST,ON_ERROR_FLAG_RINGLIST,ON_START_FETCH_KAMPANJ_KUND_PER,
ON_START_FETCH_KAMPANJ_KUND,ON_FETCH_KAMPANJ_KUND,ON_ERROR_FETCH_KAMPANJ_KUND,ON_SET_ZERO_KAMPANJ_KUND,
ON_START_KOMMENTAR_RINGLIST,ON_KOMMENTAR_RINGLIST,ON_ERROR_KOMMENTAR_RINGLIST,ON_KOMMENTAR_RINGLIST1,
ON_START_KAMPANJ_KUND_AKTIV,ON_KAMPANJ_KUND_AKTIV,ON_ERROR_KAMPANJ_KUND_AKTIV,
ON_START_KAMPANJ_KUND_BOKAMOTE,ON_KAMPANJ_KUND_BOKAMOTE,ON_ERROR_KAMPANJ_KUND_BOKAMOTE,ON_KAMPANJ_KUND_BOKAMOTE_D,
ON_START_KAMPANJ_KUND_PROSPEKT, ON_KAMPANJ_KUND_PROSPEKT, ON_ERROR_KAMPANJ_KUND_PROSPEKT,
ON_START_KAMPANJ_KUND_AVTAL, ON_KAMPANJ_KUND_AVTAL, ON_ERROR_KAMPANJ_KUND_AVTAL,
ON_START_KAMPANJ_KUND_ORDER, ON_KAMPANJ_KUND_ORDER, ON_ERROR_KAMPANJ_KUND_ORDER,
ON_START_KAMPANJ_KUND_ESIGNERING,ON_ERROR_KAMPANJ_KUND_ESIGNERING,
ON_START_KAMPANJ_KUND_AKTIVITET, ON_KAMPANJ_KUND_AKTIVITET, ON_ERROR_KAMPANJ_KUND_AKTIVITET,
ON_START_FETCH_RANDOM_KUND_LIST_BYID,ON_FETCH_RANDOM_KUND_LIST_BYID,ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID,
ON_START_FETCH_KAMPANJ_MOTE,ON_FETCH_KAMPANJ_MOTE,ON_ERROR_FETCH_KAMPANJ_MOTE,
ON_START_FETCH_KAMPANJ_PERATERKOMT,ON_FETCH_KAMPANJ_PERATERKOMT,ON_ERROR_FETCH_KAMPANJ_PERATERKOMT,
ON_START_FETCH_SEARCH_DIALERVYN,ON_FETCH_SEARCH_DIALERVYN,ON_ERROR_FETCH_SEARCH_DIALERVYN,
ON_START_FETCH_SEARCH_DIALERVYN_1,ON_FETCH_SEARCH_DIALERVYN_NOACCESS,
ON_START_FETCH_GET_NEXT_KUND, ON_FETCH_GET_NEXT_KUND, ON_ERROR_FETCH_GET_NEXT_KUND,
ON_START_IMPORT_RINGLIST,ON_IMPORT_RINGLIST,ON_ERROR_IMPORT_RINGLIST,
ON_START_FETCH_STATISTIC,ON_FETCH_STATISTIC,ON_ERROR_FETCH_STATISTIC,
ON_START_KAMPANJ_ROMVE_BLIST, ON_KAMPANJ_KUND_ROMVE_BLIST, ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST,
ON_START_FETCH_GET_BLACKLIST,ON_FETCH_GET_BLACKLIST,ON_ERROR_FETCH_GET_BLACKLIST,
ON_START_DELETE_FROM_BL, ON_DELETE_FROM_BL, ON_ERROR_DELETE_FROM_BL,
ON_START_FETCH_GET_NEXT_ORGNR, ON_FETCH_GET_NEXT_ORGNR, ON_ERROR_FETCH_GET_NEXT_ORGNR,SET_ZERO_DIALER,
ON_START_FETCH_GET_KAMPANJER,ON_FETCH_GET_KAMPANJER,ON_ERROR_FETCH_GET_KAMPANJER,ON_FETCH_KAMPANJ_KUND_KOMPANJ,
ON_FETCH_KAMPANJ_KUND_KOMPANJ_INNE,ON_FETCH_KAMPANJ_KUND_KOMPANJ_P,
ON_MOTE_LIST_DIALER,ON_START_MOTE_LIST_DIALER,ON_START_FETCH_KUND_LISTVY_BYID1,
ON_START_FETCH_KUND_LISTVY_HR_BYID,ON_FETCH_KUND_LISTVY_HR_BYID,ON_ERROR_FETCH_KUND_LISTVY_HR_BYID,
ON_START_FETCH_CHECK_ORGNR_LIST_BYID,ON_FETCH_CHECK_ORGNR_BYID,ON_ERROR_FETCH_CHECK_ORGNR_BYID,
ON_START_FETCH_GET_PERSONAL_LIST,ON_FETCH_GET_PERSONAL_LIST,ON_ERROR_FETCH_GET_PERSONAL_LIST,
ON_START_DELETE_FROM_PERSONAL_LIST, ON_DELETE_FROM_PERSONAL_LIST, ON_ERROR_DELETE_FROM_PERSONAL_LIST,
ON_START_FETCH_GET_BLACKLIST_LIST,ON_FETCH_GET_BLACKLIST_LIST,ON_ERROR_FETCH_GET_BLACKLIST_LIST,
ON_FETCH_GET_NEXT_KUND_2,ON_FETCH_GET_NEXT_KUND_1,ON_START_FETCH_GET_NEXT_KUND_2,ON_START_FETCH_GET_NEXT_KUND_1,
ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M,ON_START_FETCH_GET_NEXT_ORGNR_1,

ON_START_ADD_KD_DIALER_NEWLINE, ON_ADD_KD_DIALER_NEWLINE, ON_ERROR_ADD_KD_DIALER_NEWLINE,
ON_START_FETCH_GET_KD_DIALER,ON_FETCH_GET_KD_DIALER,ON_ERROR_FETCH_GET_KD_DIALER,
ON_UPPDATE_KD_DIALER_NEWLINE, ON_ERROR_UPPDATE_KD_DIALER_NEWLINE,
ON_DELETE_KD_DIALER_NEWLINE, ON_ERROR_DELETE_KD_DIALER_NEWLINE,
ON_START_FETCH_GET_RAPPORT_DIALER,ON_ERROR_FETCH_GET_RAPPORT_DIALER,
ON_SET_NULL_NOACCESS_DIALER,
ON_START_FETCH_LYNES_SAMTAL_HISTORY,
ON_FETCH_LYNES_SAMTAL_HISTORY,
ON_ERROR_LYNES_SAMTAL_HISTORY,
} from '../constants/ActionTypes'
import { translate } from "../util/intlHelper";
import {isEmpty, isUndefined} from 'lodash'

const INIT_STATE = {
    Hitcount:0,
    Lan:[],
    Kummon:[],
    KommunList:[],
    StatisticRingListor:[],
    RinglistorList:[],
    AvtalsTidList:[],
    AvtalsTidListAntal:0,
    BrancshCat:[],
    BrancshSubCat:[],
    Operator:[],
    FordonType:[],
    KundDataTable:[],
    isLoading:false,
    isEDLoading:false,
    KundList:[],
    CurrentKunddata:[],
    isListLoading:false,
    isList2Loading:false,
    RingListorA:[],
    RingListor:[],
    currentKampanj:{},
    Total:{},
    currentKampanjKund:{},
    isKundLoading:false,
    message:"",
    isMinaMoteLoading:false,
    MinaMote:[],
    MinaMoteAntal:0,
    isMinaPAterLoading:false,
    MinaPerAterkomst:[],
    MinaPerAterkomstAntal:0,
    kanPersonligaAterkost:1,
    AntalStatistic:[],
    BlackLTotal:0,
    BlackL:[],
    BlackListor:[],
    MinaPersonligaTotal:0,
    MinaPersonligaList:[],
    MotesPage:0,
    NextOrgnr:"",
    bufferdKund:{},
    PrevbufferdKund:{},
    Errormessage:"",
    NextOrgnrList:"",
    PrevOrgnList:"",
    isAPerRecall:0,
    RequestIsSend:0,
    isActionDone:0,
    LynesHistory:[],
    LynesHistoryLoading: false,
    History:[],
    HasNoAccess:false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ON_START_FETCH_HIT_COUNT:{
            //console.log("ON_START_FETCH_HIT_COUNT",action)
            return {
                ...state,
                isLoading:true
            }
        }
        case SET_ZERO_DIALER: {
            return INIT_STATE;
          }
        case ON_SET_NULL_NOACCESS_DIALER: {
            return {
                ...state,
                HasNoAccess:false
            }
          }
        case ON_FETCH_HIT_COUNT:{
            //console.log("ON_FETCH_HIT_COUNT",action)
            return {
                ...state,
                isLoading:false,
                isEDLoading:false,
                Hitcount:action.payload.HitCount
            }
        }
        case ON_ERROR_FETCH_HIT_COUNT:{
            //console.log("ON_ERROR_FETCH_HIT_COUNT",action)
            return {
                ...state,
                isListLoading:false
            }
        } 
        case ON_START_NEW_RINGLIST:{
            //console.log("ON_START_NEW_RINGLIST",action)
            return {
                ...state,
                isListLoading:true,
                isEDLoading:true,
                message:"",
                RingListor:[],
                Total:{}
            }
        }
        case ON_NEW_RINGLIST:{
            //console.log("ON_NEW_RINGLIST",action)
            return {
                ...state,
                isListLoading:false,
                //isListLoading:false,
                message:translate("Action.Callinglist.Create"),
               // RingListor:action.payload.RingListor,
                //Total:action.payload.Total,
            }
        }
        case ON_ERROR_NEW_RINGLIST:{
            //console.log("ON_ERROR_NEW_RINGLIST",action)
            return {
                ...state,
                message:translate("Error.Callinglist.Create"),
                isEDLoading:false,
                isLoading:false
            }
        } 
        //ON_START_FETCH_KAMPANJER_ALL,ON_FETCH_KAMPANJER_ALL,ON_ERROR_FETCH_KAMPANJER_ALL,
        case ON_START_FETCH_KAMPANJER_ALL:{
            return {
                ...state,
            }
        }
        case ON_FETCH_KAMPANJER_ALL:{
            console.log("ON_FETCH_KAMPANJER_ALL",action)
            return {
                ...state,
                RingListorA:action.payload.RingListor,
            }
        }
        case ON_ERROR_FETCH_KAMPANJER_ALL:{
            //console.log("ON_ERROR_FETCH_KAMPANJER",action)
            return {
                ...state,
                message:translate("Error.Callinglist.fetchAll")
            }
        } 
        //
        case ON_START_FETCH_KAMPANJER:{
            //console.log("ON_START_FETCH_KAMPANJER",action)
            return {
                ...state,
                isListLoading:true,
                message:"",
                RingListor:[],
                Total:{}
            }
        }
        case ON_FETCH_KAMPANJER:{
            //console.log("ON_FETCH_KAMPANJER",action)
            return {
                ...state,
                isListLoading:false,
                RingListor:action.payload.RingListor,
                KundDataTable:action.payload.KundDataTable,
                Total:action.payload.Total,
            }
        }
        case ON_ERROR_FETCH_KAMPANJER:{
            //console.log("ON_ERROR_FETCH_KAMPANJER",action)
            return {
                ...state,
                message:translate("Error.Callinglist.fetchAll"),
                isLoading:false
            }
        } 
        case ON_START_DELETE_KAMPANJER:{
            //console.log("ON_START_DELETE_KAMPANJER",action)
            return {
                ...state,
                isListLoading:true,
                message:""
            }
        }
        case ON_DELETE_KAMPANJER:{
            //console.log("ON_DELETE_KAMPANJER",action)
            return {
                ...state,
                isListLoading:false,
                message:translate("Action.Callinglist.delete"),
                RingListor:action.payload.RingListor,
                Total:action.payload.Total,
            }
        }
        case ON_ERROR_DELETE_KAMPANJER:{
            //console.log("ON_ERROR_DELETE_KAMPANJER",action)
            return {
                ...state,
                message:translate("Error.Callinglist.delete"),
                isLoading:false
            }
        } 
        case ON_START_FETCH_KUND_LIST:{
            //console.log("ON_START_FETCH_KUND_LIST",action)
            return {
                ...state,
                isListLoading:true,
                KundList:[]
            }
        }
        case ON_FETCH_KUND_LIST:{
            //console.log("ON_FETCH_KUND_LIST",action)
            return {
                ...state,
                isListLoading:false,
                KundList:action.payload.KundList,
            }
        }
        case ON_ERROR_FETCH_KUND_LIST:{
            //console.log("ON_ERROR_FETCH_KUND_LIST",action)
            return {
                ...state,
                isListLoading:false
            }
        } 
        // ,,,
        case ON_START_FETCH_KUND_LIST_BYID:{
            //console.log("ON_START_FETCH_KUND_LIST_BYID",action)
            return {
                ...state,
                isListLoading:true,
                KundList:[],
              //  currentKampanj:{}
                
            }
        }
        case ON_FETCH_KUND_LIST_BYID:{
            //console.log("ON_FETCH_KUND_LIST_BYID",action)
            return {
                ...state,
                isListLoading:false,
                KundList:action.payload.KundList,
            }
        }
        case ON_ERROR_FETCH_KUND_LIST_BYID:{
            //console.log("ON_ERROR_FETCH_KUND_LIST_BYID",action)
            return {
                ...state,
                isListLoading:false
            }
        }

        case ON_START_FETCH_RL_PREPARE:{
            //console.log("ON_START_FETCH_RL_PREPARE",action)
            return {
                ...state
            }
        }
        case ON_FETCH_RL_PREPARE:{
            //console.log("ON_FETCH_RL_PREPARE",action)
            return {
                ...state,
                Lan:action.payload.Lan,
                Kummon:action.payload.Kummon,
                BrancshCat:action.payload.BrancshCat,
                BrancshSubCat:action.payload.BrancshSubCat,
                Operator:action.payload.Operator,
                FordonType:action.payload.FordonType,
                
            }
        }
        case ON_ERROR_FETCH_RL_PREPARE:{
            //console.log("ON_ERROR_FETCH_RL_PREPARE",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_KAMPANJ_BYID:{
            //console.log("ON_START_FETCH_KAMPANJ_BYID",action)
            return {
                ...state,
                isEDLoading:true,
                currentKampanj:{}
            }
        }
        case ON_FETCH_KAMPANJ_BYID:{
            //console.log("ON_FETCH_KAMPANJ_BYID",action)
            return {
                ...state,
                currentKampanj:action.payload.currentKampanj,
            }
        } 
        case ON_ERROR_FETCH_KAMPANJ_BYID:{
            //console.log("ON_ERROR_FETCH_KAMPANJ_BYID",action)
            return {
                ...state,
                isLoading:false,
                message:translate("Error.Callinglist.fetchById"),
            }
        }
        //
        case ON_START_UPDATE_RINGLIST:{
            //console.log("ON_START_UPDATE_RINGLIST",action)
            return {
                ...state,
               // isEDLoading:true,
            }
        }
        case ON_UPDATE_RINGLIST:{
            //console.log("ON_UPDATE_RINGLIST",action)
            return {
                ...state,
                isEDLoading:false,
                message:translate("Action.Callinglist.update"),
                currentKampanj:action.payload.currentKampanj,
            }
        } 
        case ON_ERROR_UPDATE_RINGLIST:{
            //console.log("ON_ERROR_UPDATE_RINGLIST",action)
            return {
                ...state,
                isEDLoading:false,
                message:translate("Error.Callinglist.update"),
            }
        }
        case ON_START_FETCH_KUND_LISTVY_BYID:{
            //console.log("ON_START_FETCH_KUND_LISTVY_BYID",action)
            return {
                ...state,
                currentKampanjKund:{} ,
                bufferdKund:{},
                currentKampanj:{},
                isListLoading:true,
                isList2Loading:true,
                KundList:[],                
            }
        }
        case ON_START_FETCH_KUND_LISTVY_BYID1:{
            //console.log("ON_START_FETCH_KUND_LISTVY_BYID",action)
            return {
                ...state,
                currentKampanjKund:{} ,
                bufferdKund:{},
                isListLoading:true,
                isList2Loading:true,
                KundList:[],                
            }
        }
        case ON_FETCH_KUND_LISTVY_BYID:{
            //console.log("ON_FETCH_KUND_LISTVY_BYID",action)
            return {
                ...state,
                isListLoading:false,
                isList2Loading:false,
                currentKampanj:{
                    ...state.currentKampanj,
                    minSida:action.payload.Page
                },
                KundList:action.payload.KundList,
               // Hitcount:action.payload.HitCount
            }
        }
        case ON_ERROR_FETCH_KUND_LISTVY_BYID:{
            //console.log("ON_ERROR_FETCH_KUND_LISTVY_BYID",action)
            return {
                ...state,
                isListLoading:false,
                isList2Loading:false
            }
        }
        //,ON_FLAG_RINGLIST,ON_ERROR_FLAG_RINGLIST,
        case ON_START_FLAG_RINGLIST:{
            //console.log("ON_START_FLAG_RINGLIST",action)
            return {
                ...state,               
            }
        }
        case ON_FLAG_RINGLIST:{
            //console.log("ON_FLAG_RINGLIST",action)
            return {
                ...state,
            }
        }
        case ON_ERROR_FLAG_RINGLIST:{
            //console.log("ON_ERROR_FLAG_RINGLIST",action)
            return {
                ...state,
                message:translate("Error.Callinglist.flag")
            }
        }
        //
        case ON_START_FETCH_KAMPANJ_KUND:{
            //console.log("ON_START_FETCH_KAMPANJ_KUND",action)
            return {
                ...state,
                isKundLoading:true,               
                // currentKampanjKund:{} ,
                NextOrgnr:"",
                isAPerRecall:0
            }
        }
        case ON_START_FETCH_KAMPANJ_KUND_PER:{
            //console.log("ON_START_FETCH_KAMPANJ_KUND",action)
            return {
                ...state,
                HasNoAccess:false,
                isKundLoading:true,               
                // currentKampanjKund:{} ,
                //NextOrgnr:"",
                isAPerRecall:0
            }
        }
        case ON_FETCH_KAMPANJ_KUND:{
            //console.log("ON_FETCH_KAMPANJ_KUND",action)
            return {
                ...state,
                
                isKundLoading:false,
                currentKampanjKund:action.payload.currentKampanjKund,
                kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
                isAPerRecall:0,
                NextOrgnr:action.payload.NextOrgnr,
                bufferdKund:action.payload.currentKampanjKund,
                NextOrgnrList:"",
                PrevOrgnList:""
            }
        }
        case ON_FETCH_KAMPANJ_KUND_KOMPANJ:{
            //console.log("ON_FETCH_KAMPANJ_KUND_KOMPANJ",action)
            return {
                ...state,
                isKundLoading:false,
                currentKampanjKund:action.payload.currentKampanjKund,
                kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
                currentKampanj:action.payload.currentKampanj,
                //NextOrgnr:action.payload.NextOrgnr,
                //bufferdKund:action.payload.currentKampanjKund,
                isAPerRecall:0
            }
        }
        case ON_FETCH_KAMPANJ_KUND_KOMPANJ_P:{
            console.log("ON_FETCH_KAMPANJ_KUND_KOMPANJ_P",action)
            console.log("ON_FETCH_KAMPANJ_KUND_KOMPANJ_P",state.currentKampanj)
            return {
                ...state,
                isKundLoading:false,
                currentKampanjKund:action.payload.currentKampanjKund,
                kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
                currentKampanj:!isEmpty(state.currentKampanj)?state.currentKampanj:action.payload.currentKampanj,
                //NextOrgnr:action.payload.NextOrgnr,
                //bufferdKund:action.payload.currentKampanjKund,
                isAPerRecall:1
            }
        }
        case ON_FETCH_KAMPANJ_KUND_KOMPANJ_INNE:{
            //console.log("ON_FETCH_KAMPANJ_KUND_KOMPANJ",action)
            return {
                ...state,
                isKundLoading:false,
                currentKampanjKund:action.payload.currentKampanjKund,
                kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
                currentKampanj:parseInt(action.payload.listID)===0?state.currentKampanj:action.payload.currentKampanj,
                //NextOrgnr:action.payload.NextOrgnr,
                //bufferdKund:action.payload.currentKampanjKund,
                isAPerRecall:1
            }
        }
        case ON_ERROR_FETCH_KAMPANJ_KUND:{
            //console.log("ON_ERROR_FETCH_KAMPANJ_KUND",action)
            return {
                ...state,
                isKundLoading:false,
                message:translate("Error.Callinglist.Client.fetch")
            }
        }
        case ON_SET_ZERO_KAMPANJ_KUND:{
            //console.log("ON_SET_ZERO_KAMPANJ_KUND",action)
            return {
                ...state,
                isKundLoading:false,
                currentKampanjKund:{}
            }
        }
        // ,,ON_ERROR_KOMMENTAR_RINGLIST,
        case ON_START_KOMMENTAR_RINGLIST:{
            //console.log("ON_START_KOMMENTAR_RINGLIST",action)
            return {
                ...state,
                isKundLoading:false,    
            }
        }
        case ON_KOMMENTAR_RINGLIST:{
            //console.log("ON_KOMMENTAR_RINGLIST",action)
            return {
                ...state,
                isKundLoading:false,
              //  currentKampanjKund:action.payload.currentKampanjKund,
                isAPerRecall:0
            }
        }
        case ON_KOMMENTAR_RINGLIST1:{
            //console.log("ON_KOMMENTAR_RINGLIST",action)
            return {
                ...state,
                isKundLoading:false,
             //   currentKampanjKund:action.payload.currentKampanjKund,
                isAPerRecall:1
            }
        }
        case ON_ERROR_KOMMENTAR_RINGLIST:{
            //console.log("ON_ERROR_KOMMENTAR_RINGLIST",action)
            return {
                ...state,
                isKundLoading:false,
                message:translate("Error.Callinglist.Client.Commentar.add")
            }
        }
        //,,ON_ERROR_KAMPANJ_KUND_AKTIV,
        case ON_START_KAMPANJ_KUND_AKTIV:{
            //console.log("ON_START_KAMPANJ_KUND_AKTIV",action)
            return {
                ...state,
                isKundLoading:true,    
            }
        }
        case ON_KAMPANJ_KUND_AKTIV:{
            //console.log("ON_KAMPANJ_KUND_AKTIV",action)
            return {
                ...state,
                isKundLoading:false,
                currentKampanjKund:action.payload.currentKampanjKund,
                message:translate("Action.Callinglist.Client.Active")
            }
        }
        case ON_ERROR_KAMPANJ_KUND_AKTIV:{
            //console.log("ON_ERROR_KAMPANJ_KUND_AKTIV",action)
            return {
                ...state,
                isKundLoading:false,
                message:translate("Error.Callinglist.Client.Active")
            }
        }
//,,,
case ON_START_KAMPANJ_KUND_BOKAMOTE:{
    //console.log("ON_START_KAMPANJ_KUND_BOKAMOTE",action)
    return {
        ...state,
        isKundLoading:false, 
        isActionDone:0   
    }
}
case ON_KAMPANJ_KUND_BOKAMOTE_D:{
    return {
        ...state,
        isActionDone:1,
        message:translate("Action.Callinglist.Event.Booking"),
    }
}
case ON_KAMPANJ_KUND_BOKAMOTE:{
    //console.log("ON_KAMPANJ_KUND_BOKAMOTE",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:action.payload.currentKampanjKund,
        message:translate("Action.Callinglist.Event.Booking"),
        isActionDone:1
    }
}
case ON_ERROR_KAMPANJ_KUND_BOKAMOTE:{
    //console.log("ON_ERROR_KAMPANJ_KUND_BOKAMOTE",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.Callinglist.Event.Booking"),
        isActionDone:2
    }
}
//, , ,
case ON_START_KAMPANJ_KUND_PROSPEKT:{
    //console.log("ON_START_KAMPANJ_KUND_PROSPEKT",action)
    return {
        ...state,
        isKundLoading:true,    
    }
}
case ON_KAMPANJ_KUND_PROSPEKT:{
    //console.log("ON_KAMPANJ_KUND_PROSPEKT",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:action.payload.currentKampanjKund,
        message:translate("Action.Callinglist.prospect.create")
    }
}
case ON_ERROR_KAMPANJ_KUND_PROSPEKT:{
    //console.log("ON_ERROR_KAMPANJ_KUND_PROSPEKT",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.Callinglist.prospect.create")
    }
}
//ON_START_KAMPANJ_KUND_ESIGNERING,ON_ERROR_KAMPANJ_KUND_ESIGNERING,
case ON_START_KAMPANJ_KUND_ESIGNERING:{
    //console.log("ON_START_KAMPANJ_KUND_ESIGNERING",action)
    return {
        ...state,
        isKundLoading:true,    
    }
}
case ON_ERROR_KAMPANJ_KUND_ESIGNERING:{
    //console.log("ON_ERROR_KAMPANJ_KUND_ESIGNERING",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.Callinglist.Esigning.create")
    }
}
//
case ON_START_KAMPANJ_KUND_AVTAL:{
    //console.log("ON_START_KAMPANJ_KUND_AVTAL",action)
    return {
        ...state,
        isKundLoading:true,    
    }
}
case ON_KAMPANJ_KUND_AVTAL:{
    //console.log("ON_KAMPANJ_KUND_AVTAL",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:action.payload.currentKampanjKund,
        message:translate("Action.Callinglist.Contract.create")
    }
}
case ON_ERROR_KAMPANJ_KUND_AVTAL:{
    //console.log("ON_ERROR_KAMPANJ_KUND_AVTAL",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.Callinglist.Contract.create")
    }
}
//, , ,
case ON_START_KAMPANJ_KUND_ORDER:{
    //console.log("ON_START_KAMPANJ_KUND_ORDER",action)
    return {
        ...state,
        isKundLoading:true,    
    }
}
case ON_KAMPANJ_KUND_ORDER:{
    //console.log("ON_KAMPANJ_KUND_ORDER",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:action.payload.currentKampanjKund,
        message:translate("Action.Callinglist.Order.create")
    }
}
case ON_ERROR_KAMPANJ_KUND_ORDER:{
    //console.log("ON_ERROR_KAMPANJ_KUND_ORDER",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.Callinglist.Order.create")
    }
}
//, , ,
case ON_START_KAMPANJ_KUND_AKTIVITET:{
    //console.log("ON_START_KAMPANJ_KUND_AKTIVITET",action)
    return {
        ...state,
        isKundLoading:true,    
    }
}
case ON_KAMPANJ_KUND_AKTIVITET:{
    //console.log("ON_KAMPANJ_KUND_AKTIVITET",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:action.payload.currentKampanjKund,
        message:translate("Action.Callinglist.Activity.create")
    }
}
case ON_ERROR_KAMPANJ_KUND_AKTIVITET:{
    //console.log("ON_ERROR_KAMPANJ_KUND_AKTIVITET",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.Callinglist.Activity.create")
    }
}
//
case ON_START_FETCH_RANDOM_KUND_LIST_BYID:{
    console.log("ON_START_FETCH_RANDOM_KUND_LIST_BYID",action)
    return {
        ...state,
        HasNoAccess:false,
        isKundLoading:true,    
        isAPerRecall:0,
        currentKampanjKund:{},
        RequestIsSend:1
    }
}
case ON_FETCH_RANDOM_KUND_LIST_BYID:{
    console.log("ON_FETCH_RANDOM_KUND_LIST_BYID",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:isEmpty(action.payload.currentKampanjKund)?{list:0}:action.payload.currentKampanjKund,
        kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
        message:action.payload.message,
        Errormessage:isEmpty(action.payload.currentKampanjKund)?translate("Message.List.isEmpty"):"",
        RequestIsSend:0
    }
}
case ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID:{
    console.log("ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID",action)
    return {
        ...state,
        isKundLoading:false,
        Errormessage:translate("Message.List.isEmpty"),
        message:"Error",
        RequestIsSend:0
    }
}
case ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M:{
   // console.log("ON_ERROR_FETCH_RANDOM_KUND_LIST_BYID_M",action)
    return {
        ...state,
        isKundLoading:false,
        Errormessage:translate("Message.Callinglist.timeOut"),
        message:"Error",
        RequestIsSend:0
    }
}
//ON_START_FETCH_CHECK_ORGNR_LIST_BYID,ON_FETCH_CHECK_ORGNR_BYID,ON_ERROR_FETCH_CHECK_ORGNR_BYID,
case ON_START_FETCH_CHECK_ORGNR_LIST_BYID:{
    //console.log("ON_START_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        RequestIsSend:1
    }
}
case ON_FETCH_CHECK_ORGNR_BYID:{
    //console.log("ON_START_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        RequestIsSend:0 
    }
}
case ON_ERROR_FETCH_CHECK_ORGNR_BYID:{
    //console.log("ON_START_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state    
    }
}
//ON_MOTE_LIST_DIALER,ON_START_MOTE_LIST_DIALER,
case ON_START_MOTE_LIST_DIALER:{
    //console.log("ON_START_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        MotesPage:0,    
    }
}
case ON_MOTE_LIST_DIALER:{
    //console.log("ON_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        MotesPage:1, 
    }
}
//MotesPage
case ON_START_FETCH_KAMPANJ_MOTE:{
    //console.log("ON_START_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        isMinaMoteLoading:true,    
    }
}
case ON_FETCH_KAMPANJ_MOTE:{
    //console.log("ON_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        isMinaMoteLoading:false,
        MinaMote:action.payload.MinaMote,
        MinaMoteAntal:action.payload.MinaMoteAntal,
    }
}
case ON_ERROR_FETCH_KAMPANJ_MOTE:{
    //console.log("ON_ERROR_FETCH_KAMPANJ_MOTE",action)
    return {
        ...state,
        isMinaMoteLoading:false,
        message:translate("Error.Callinglist.Events.getAll")
    }
}
//,,,
case ON_START_FETCH_KAMPANJ_PERATERKOMT:{
    //console.log("ON_START_FETCH_KAMPANJ_PERATERKOMT",action)
    return {
        ...state,
        isMinaPAterLoading:true,    
    }
}
case ON_FETCH_KAMPANJ_PERATERKOMT:{
    //console.log("ON_FETCH_KAMPANJ_PERATERKOMT",action)
    return {
        ...state,
        isMinaPAterLoading:false,
        MinaPerAterkomst:action.payload.MinaPerAterkomst,
        MinaPerAterkomstAntal:action.payload.MinaPerAterkomstAntal,
    }
}
case ON_ERROR_FETCH_KAMPANJ_PERATERKOMT:{
    //console.log("ON_ERROR_FETCH_KAMPANJ_PERATERKOMT",action)
    return {
        ...state,
        isMinaPAterLoading:false,
        message:translate("Error.Callinglist.PersonalRecall.getAll")
    }
}
case ON_START_FETCH_SEARCH_DIALERVYN:{
    console.log("ON_START_FETCH_SEARCH_DIALERVYN",action)
    return {
        ...state,
       // NextOrgnr:"",
        isKundLoading:true,    
    }
}
case ON_START_FETCH_SEARCH_DIALERVYN_1:{
    console.log("ON_START_FETCH_SEARCH_DIALERVYN_1",action)
    return {
        ...state,
    }
}
case ON_FETCH_SEARCH_DIALERVYN:{
    //console.log("ON_FETCH_SEARCH_DIALERVYN",action)
    return {
        ...state,
        isKundLoading:false,
        HasNoAccess:false,
        currentKampanjKund:isEmpty(action.payload.currentKampanjKund)?{list:0,Isnot:0}:action.payload.currentKampanjKund,
        kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
        message:"",
       // NextOrgnr:action.payload.NextOrgnr,
       // bufferdKund:isEmpty(action.payload.currentKampanjKund)?{list:0,Isnot:0}:action.payload.currentKampanjKund,
        isAPerRecall:0
    }
}
case ON_FETCH_SEARCH_DIALERVYN_NOACCESS:{
    console.log("ON_FETCH_SEARCH_DIALERVYN_NOACCESS",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:[],
        HasNoAccess:true,
        message:translate("Label.ClientAccess.HasNoAccess.message"),
        Errormessage:translate("Label.ClientAccess.HasNoAccess.message"),
        isAPerRecall:0
    }
}

case ON_ERROR_FETCH_SEARCH_DIALERVYN:{
    //console.log("ON_ERROR_FETCH_SEARCH_DIALERVYN",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Message.Callinglist.noMatched")
    }
}
//,,ON_ERROR_IMPORT_RINGLIST,
case ON_START_IMPORT_RINGLIST:{
    //console.log("ON_START_IMPORT_RINGLIST",action)
    return {
        ...state,
        isListLoading:true,
        isEDLoading:true,
        message:"",
        RingListor:[],
        Total:{}
    }
}
case ON_IMPORT_RINGLIST:{
    //console.log("ON_IMPORT_RINGLIST",action)
    return {
        ...state,
        isListLoading:false,
        isEDLoading:false,
        message:translate("Action.callinglist.Import"),
        RingListor:action.payload.RingListor,
        Total:action.payload.Total,
    }
}
case ON_ERROR_IMPORT_RINGLIST:{
    //console.log("ON_ERROR_IMPORT_RINGLIST",action)
    return {
        ...state,
        message:translate("Error.callinglist.Import"),
        isEDLoading:false,
        isLoading:false
    }
} 
//,,,
case ON_START_FETCH_STATISTIC:{
    //console.log("ON_START_FETCH_STATISTIC",action)
    return {
        ...state,
    }
}
case ON_FETCH_STATISTIC:{
    //console.log("ON_FETCH_STATISTIC",action)
    //console.log(action.payload.AntalStatistic)
    //console.log(state.AntalStatistic)
    let Array1 = state.AntalStatistic
    Array1.push(action.payload.AntalStatistic)
    return {
        ...state,
        AntalStatistic:Array1,
    }
}
case ON_ERROR_FETCH_STATISTIC:{
    //console.log("ON_ERROR_FETCH_STATISTIC",action)
    //console.log(state.AntalStatistic)
    return {
        ...state,
        message:translate("Error.callinglist.Statistic.fetch"),
    }
} 
//,,,
case ON_START_FETCH_STATISTIC_KAMPANJER:{
    //console.log("ON_START_FETCH_STATISTIC_KAMPANJER",action)
    return {
        ...state,
        isListLoading:true,
        message:"",
        StatisticRingListor:[],
        Total:{}
    }
}
case ON_FETCH_STATISTIC_KAMPANJER:{
    //console.log("ON_FETCH_STATISTIC_KAMPANJER",action)
    return {
        ...state,
        isListLoading:false,
        StatisticRingListor:action.payload.StatisticRingListor,
        Total:action.payload.Total,
    }
}
case ON_ERROR_FETCH_STATISTIC_KAMPANJER:{
    //console.log("ON_ERROR_FETCH_STATISTIC_KAMPANJER",action)
    return {
        ...state,
        message:translate("Error.callinglist.Statistic.fetch"),
        isLoading:false
    }
} 
//ON_START_KAMPANJ_ROMVE_BLIST, ON_KAMPANJ_KUND_ROMVE_BLIST, ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST,
case ON_START_KAMPANJ_ROMVE_BLIST:{
    //console.log("ON_START_KAMPANJ_ROMVE_BLIST",action)
    return {
        ...state,
        isKundLoading:true,    
    }
}
case ON_KAMPANJ_KUND_ROMVE_BLIST:{
    //console.log("ON_KAMPANJ_KUND_ROMVE_BLIST",action)
    return {
        ...state,
        isKundLoading:false,
        currentKampanjKund:isEmpty(action.payload.currentKampanjKund)?{list:0,Isnot:0}:action.payload.currentKampanjKund,
        kanPersonligaAterkost:action.payload.kanPersonligaAterkost,
        message:""
    }
}
case ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST:{
    //console.log("ON_ERROR_KAMPANJ_KUND_ROMVE_BLIST",action)
    return {
        ...state,
        isKundLoading:false,
        message:translate("Error.callinglist.No.matched")
    }
}
//,,,
case ON_START_FETCH_GET_KAMPANJER:{
    //console.log("ON_START_FETCH_GET_KAMPANJER",action)
    return {
        ...state,   
    }
}
case ON_FETCH_GET_KAMPANJER:{
    //console.log("ON_START_KAMPANJ_ROMVE_BLIST",action)
    return {
        ...state,
        RinglistorList:action.payload.RinglistorList
    }
}
case ON_ERROR_FETCH_GET_KAMPANJER:{
    //console.log("ON_ERROR_FETCH_GET_KAMPANJER",action)
    return {
        ...state,   
        message:translate("Error.callinglist.fetchAll"),
    }
}
//,,ON_ERROR_FETCH_GET_BLACKLIST,
case ON_START_FETCH_GET_BLACKLIST:{
    //console.log("ON_START_FETCH_GET_BLACKLIST",action)
    return {
        ...state,   
        message:"",
    }
}
case ON_FETCH_GET_BLACKLIST:{
    //console.log("ON_FETCH_GET_BLACKLIST",action)
    return {
        ...state,
        BlackL:action.payload.BlackList,
        BlackLTotal:action.payload.antal
    }
}
case ON_ERROR_FETCH_GET_BLACKLIST:{
    //console.log("ON_ERROR_FETCH_GET_BLACKLIST",action)
    return {
        ...state,   
        message:translate("Error.callinglist.Blacklist.fetchAll"),
    }
}
//ON_START_DELETE_FROM_BL, ON_DELETE_FROM_BL, ON_ERROR_DELETE_FROM_BL,
case ON_START_DELETE_FROM_BL:{
    //console.log("ON_START_DELETE_FROM_BL",action)
    return {
        ...state,   
        message:"",
        isListLoading:true
    }
}
case ON_DELETE_FROM_BL:{
    //console.log("ON_DELETE_FROM_BL",action)
    return {
        ...state,
        BlackL:action.payload.BlackList,
        message:translate("Action.callinglist.Blacklist.remove"),
        isListLoading:false,
        BlackLTotal:action.payload.antal
    }
}
case ON_ERROR_DELETE_FROM_BL:{
    //console.log("ON_ERROR_DELETE_FROM_BL",action)
    return {
        ...state,   
        isListLoading:false,
        message:translate("Error.callinglist.Blacklist.remove"),
    }
}
// ON_START_FETCH_GET_NEXT_ORGNR, ON_FETCH_GET_NEXT_ORGNR, ON_ERROR_FETCH_GET_NEXT_ORGNR,
case ON_START_FETCH_GET_NEXT_ORGNR:{
    //console.log("ON_START_FETCH_GET_NEXT_ORGNR",action)
   // console.log(state.bufferdKund,"DDDDDDDD")
    return {
        ...state,   
        NextOrgnr:"",
        isKundLoading:false,
        currentKampanjKund:isEmpty(state.bufferdKund)?state.currentKampanjKund:state.bufferdKund,
        bufferdKund:{},
        RequestIsSend:1
    }
}
case ON_START_FETCH_GET_NEXT_ORGNR_1:{
    //console.log("ON_START_FETCH_GET_NEXT_ORGNR",action)
   // console.log(state.bufferdKund,"DDDDDDDD")
    return {
        ...state,   
        NextOrgnr:"",
        isKundLoading:false,
        //currentKampanjKund:isEmpty(state.bufferdKund)?state.currentKampanjKund:state.bufferdKund,
        bufferdKund:{},
        RequestIsSend:1
    }
}
case ON_FETCH_GET_NEXT_ORGNR:{
   // console.log("ON_FETCH_GET_NEXT_ORGNR",action)
    if(action.payload.NextOrgnr === 'Kampajen är slut'){
        return {
            ...state,
            NextOrgnr:translate("Action.callinglist.End"),
            bufferdKund:{},
           // currentKampanjKund:{},
            RequestIsSend:0
        }
    }else{
        return {
            ...state,
            NextOrgnr:action.payload.NextOrgnr,
            bufferdKund:action.payload.currentKampanjKund,
            RequestIsSend:0
        }
    }
}
case ON_ERROR_FETCH_GET_NEXT_ORGNR:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_ORGNR",action)
    return {
        ...state,
        RequestIsSend:0
    }
}
//,,,
case ON_START_FETCH_KUND_LISTVY_HR_BYID:{
    //console.log("ON_START_FETCH_KUND_LISTVY_HR_BYID",action)
    return {
        ...state,   
        Hitcount:0,
    }
}
case ON_FETCH_KUND_LISTVY_HR_BYID:{
    //console.log("ON_FETCH_KUND_LISTVY_HR_BYID",action)
    return {
        ...state,
        Hitcount:action.payload.HitCount
    }
}
case ON_ERROR_FETCH_KUND_LISTVY_HR_BYID:{
    //console.log("ON_ERROR_FETCH_KUND_LISTVY_HR_BYID",action)
    return {
        ...state
    }
}
//NextOrgnr
//,,,
case ON_START_FETCH_GET_PERSONAL_LIST:{
    //console.log("ON_START_FETCH_GET_PERSONAL_LIST",action)
    return {
        ...state,   
        message:"",
    }
}
case ON_FETCH_GET_PERSONAL_LIST:{
    //console.log("ON_FETCH_GET_PERSONAL_LIST",action)
    return {
        ...state,
        MinaPersonligaList:action.payload.MinaPersonligaList,
        MinaPersonligaTotal:action.payload.MinaPersonligaTotal
    }
}
case ON_ERROR_FETCH_GET_PERSONAL_LIST:{
    //console.log("ON_ERROR_FETCH_GET_PERSONAL_LIST",action)
    return {
        ...state,   
        message:"Error",
    }
}
//, , ,
case ON_START_DELETE_FROM_PERSONAL_LIST:{
    //console.log("ON_START_DELETE_FROM_PERSONAL_LIST",action)
    return {
        ...state,   
        message:"",
        isListLoading:true
    }
}
case ON_DELETE_FROM_PERSONAL_LIST:{
    //console.log("ON_DELETE_FROM_PERSONAL_LIST",action)
    return {
        ...state,
        MinaPersonligaList:action.payload.MinaPersonligaList,
        message:translate("Action.callinglist.Blacklist.remove"),
        isListLoading:false,
        MinaPersonligaTotal:action.payload.MinaPersonligaTotal
    }
}
case ON_ERROR_DELETE_FROM_PERSONAL_LIST:{
    //console.log("ON_ERROR_DELETE_FROM_PERSONAL_LIST",action)
    return {
        ...state,   
        isListLoading:false,
        message:translate("Error.callinglist.Blacklist.remove"),
    }
}
//ON_START_FETCH_GET_BLACKLIST_LIST,ON_FETCH_GET_BLACKLIST_LIST,ON_ERROR_FETCH_GET_BLACKLIST_LIST,
case ON_START_FETCH_GET_BLACKLIST_LIST:{
    //console.log("ON_START_FETCH_GET_BLACKLIST_LIST",action)
    return {
        ...state,   
        message:"",
    }
}
case ON_FETCH_GET_BLACKLIST_LIST:{
    //console.log("ON_FETCH_GET_BLACKLIST_LIST",action)
    return {
        ...state,
        BlackListor:action.payload.BlackListor,
    }
}
case ON_ERROR_FETCH_GET_BLACKLIST_LIST:{
    //console.log("ON_ERROR_FETCH_GET_BLACKLIST_LIST",action)
    return {
        ...state,   
        message:translate("Error 8021: Kunde inte hämta!"),
    }
}
/*
NextOrgnrList:"",
PrevOrgnList:""
*/
//ON_START_FETCH_GET_NEXT_KUND, ON_FETCH_GET_NEXT_KUND, ON_ERROR_FETCH_GET_NEXT_KUND,
case ON_START_FETCH_GET_NEXT_KUND:{
    //console.log("ON_START_FETCH_GET_NEXT_ORGNR",action)
    return {
        ...state,   
        NextOrgnrList:"",
        isKundLoading:false,
        currentKampanjKund:isEmpty(state.bufferdKund)?state.currentKampanjKund:state.bufferdKund,
        bufferdKund:{}
    }
}
case ON_FETCH_GET_NEXT_KUND:{
 //   console.log("ON_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        NextOrgnrList:action.payload.NextOrgnr,
        currentKampanj:{
            ...state.currentKampanj,
            minSida:action.payload.Page
        },
        bufferdKund:action.payload.currentKampanjKund
    }
}
case ON_ERROR_FETCH_GET_NEXT_KUND:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state
    }
}
//ON_FETCH_GET_NEXT_KUND_2,ON_FETCH_GET_NEXT_KUND_1,ON_START_FETCH_GET_NEXT_KUND_2,ON_START_FETCH_GET_NEXT_KUND_1,
case ON_START_FETCH_GET_NEXT_KUND_1:{
  //  console.log("ON_START_FETCH_GET_NEXT_ORGNR",state.currentKampanjKund)
    return {
        ...state,   
        NextOrgnrList:"",
        PrevOrgnList:state.currentKampanjKund.Kund.Orgnr,
        isKundLoading:false,
        PrevbufferdKund:state.currentKampanjKund,
        currentKampanjKund:isEmpty(state.bufferdKund)?state.currentKampanjKund:state.bufferdKund,
        bufferdKund:{}
    }
}
case ON_FETCH_GET_NEXT_KUND_1:{
  //  console.log("ON_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        NextOrgnrList:action.payload.NextOrgnr,
        currentKampanj:{
            ...state.currentKampanj,
            minSida:action.payload.Page
        },
        bufferdKund:action.payload.currentKampanjKund
    }
}
case ON_START_FETCH_GET_NEXT_KUND_2:{
    //console.log("ON_START_FETCH_GET_NEXT_ORGNR",action)
    return {
        ...state,   
        PrevOrgnList:"",
        NextOrgnrList:state.currentKampanjKund.Kund.Orgnr,
        isKundLoading:false,
        bufferdKund:state.currentKampanjKund,
        currentKampanjKund:isEmpty(state.PrevbufferdKund)?state.currentKampanjKund:state.PrevbufferdKund,
        PrevbufferdKund:{}
    }
}
case ON_FETCH_GET_NEXT_KUND_2:{
   // console.log("ON_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        PrevOrgnList:action.payload.NextOrgnr,
        currentKampanj:{
            ...state.currentKampanj,
            minSida:action.payload.Page
        },
        PrevbufferdKund:action.payload.currentKampanjKund
    }
}
//ON_START_ADD_KD_DIALER_NEWLINE, ON_ADD_KD_DIALER_NEWLINE, ON_ERROR_ADD_KD_DIALER_NEWLINE,
case ON_START_ADD_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state
    }
}
case ON_ADD_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        CurrentKunddata:action.payload.CurrentKunddata,
        message:translate("Action.callinglist.Client.data.save")
    }
}
case ON_ERROR_ADD_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Error.callinglist.Client.data.save")
    }
}
//ON_START_FETCH_GET_KD_DIALER,ON_FETCH_GET_KD_DIALER,ON_ERROR_FETCH_GET_KD_DIALER,
case ON_START_FETCH_GET_KD_DIALER:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        CurrentKunddata:[]
    }
}
case ON_FETCH_GET_KD_DIALER:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        CurrentKunddata:action.payload.CurrentKunddata,
    }
}
case ON_ERROR_FETCH_GET_KD_DIALER:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Error.callinglist.Client.data.fetch")
    }
}
//ON_UPPDATE_KD_DIALER_NEWLINE, ON_ERROR_UPPDATE_KD_DIALER_NEWLINE,
case ON_UPPDATE_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        //CurrentKunddata:action.payload.CurrentKunddata,
        message:translate("Action.callinglist.Client.data.save")
    }
}
case ON_ERROR_UPPDATE_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Error.callinglist.Client.data.save")
    }
}
//ON_DELETE_KD_DIALER_NEWLINE, ON_ERROR_DELETE_KD_DIALER_NEWLINE,
case ON_DELETE_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        //CurrentKunddata:action.payload.CurrentKunddata,
        message:translate("Action.callinglist.client.date.delete")
    }
}
case ON_ERROR_DELETE_KD_DIALER_NEWLINE:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Error.callinglist.client.date.delete")
    }
}
//ON_START_FETCH_GET_RAPPORT_DIALER
case ON_START_FETCH_GET_RAPPORT_DIALER:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Action.callinglist.report.send")
    }
}
case ON_ERROR_FETCH_GET_RAPPORT_DIALER:{
    console.log("ON_ERROR_FETCH_GET_NEXT_KUND","DDDDDDD")
    return {
        ...state,
        //message:"Listan har inga Kunddata"
    }
}
//ON_START_GET_DIALER_AVTALSTID_LIST,ON_GET_DIALER_AVTALSTID_LIST,ON_ERROR_GET_DIALER_AVTALSTID_LIST,
case ON_START_GET_DIALER_AVTALSTID_LIST:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
    }
}
case ON_GET_DIALER_AVTALSTID_LIST:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        AvtalsTidList:action.payload.AvtalsTidList,
        AvtalsTidListAntal:action.payload.AvtalsTidListAntal,
    }
}
case ON_ERROR_GET_DIALER_AVTALSTID_LIST:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Error.callinglist.ContractPeriod.fetch")
    }
}
//ON_START_GET_DIALER_KOMMUN_LIST,ON_GET_DIALER_KOMMUN_LIST,ON_ERROR_GET_DIALER_KOMMUN_LIST,
case ON_START_GET_DIALER_KOMMUN_LIST:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
    }
}
case ON_GET_DIALER_KOMMUN_LIST:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    let KommunList = state.KommunList
    if(state.KommunList.some(item=>item.Lan === action.payload.KommunList.Lan) === false){
        KommunList.push(action.payload.KommunList)
    }
    return {
        ...state,
        KommunList:KommunList
    }
}
case ON_ERROR_GET_DIALER_KOMMUN_LIST:{
    //console.log("ON_ERROR_FETCH_GET_NEXT_KUND",action)
    return {
        ...state,
        message:translate("Error.callinglist.Municipality")
    }
}

case ON_START_FETCH_LYNES_SAMTAL_HISTORY: {
  return {
    ...state,
    LynesHistory: [],
    LynesHistoryLoading: true
  }
}
case ON_FETCH_LYNES_SAMTAL_HISTORY: {
  return {
    ...state,
    LynesHistory: action.payload.LynesHistory,
    LynesHistoryLoading: false
  }
}
case ON_ERROR_LYNES_SAMTAL_HISTORY: {
  return {
    ...state,
    LynesHistory: [],
    LynesHistoryLoading: false
  }
}
//ON_START_UPPDATE_DIALER_KOMMMENTAR, ON_UPPDATE_DIALER_KOMMMENTAR, ON_ERROR_UPPDATE_DIALER_KOMMMENTAR,
case ON_START_UPPDATE_DIALER_KOMMMENTAR:{
    return {
        ...state
    }
}
case ON_UPPDATE_DIALER_KOMMMENTAR:{
    return {
        ...state,
        currentKampanjKund:{
            ...state.currentKampanjKund,
            Logg:action.payload.Logg
        }
    }
}
case ON_ERROR_UPPDATE_DIALER_KOMMMENTAR:{
    return {
        ...state,
        message:translate("Error.callinglist.update.message")
    }
}
case ON_SET_NULL_MESSAGE_DIALER:{
    return {
        ...state,
        message:""
    }
}
//ON_START_GET_DIALER_USER_HISTORY,ON_GET_DIALER_USER_HISTORY,ON_ERROR_GET_DIALER_USER_HISTORY,
case ON_START_GET_DIALER_USER_HISTORY:{
    return {
        ...state,
    }
}
case ON_ERROR_GET_DIALER_USER_HISTORY:{
    return {
        ...state,
    }
}
case ON_GET_DIALER_USER_HISTORY:{
    return {
        ...state,
        History:action.payload.History
    }
}
//History
default: return state;
    }
}
